import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from './resources/en.json';
import ja from './resources/ja.json';

type Translations = typeof en & typeof ja;

type NameSpace = keyof typeof en;
export const defaultNS: NameSpace = 'login';

export const resources: Record<string, Translations> = {
  en,
  ja,
} as const;

// eslint-disable-next-line @typescript-eslint/no-floating-promises
i18n.use(initReactI18next).use(LanguageDetector).init({
  defaultNS,
  fallbackLng: 'en',
  resources,
});

export { i18n };
